module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACWSURBVHgBvZDNDcIwDIWfIy7cOkKOkCUwGzBCjy0nVmAS2IAV2IQ5uNRNqjaHqn9x1X5SZCt++hQH2ArH99eJCzuXM6MTktwPGWrBQvYROC7ycNQCaf7CXNSCKaLgzOXNXcsfEokCgmS+WCSSvILlRxZeqxYc8WcifNSCdlWoBX0OXVMBXyP0jhORZ7hrWl8lJIZya6kBX9gfydYx+3kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/left-menu-active-6.png
// module id = 2677
// module chunks = 0